import { call, fork, select, takeLatest } from 'redux-saga/effects';

import { fetchTeamMemberByIds } from '../api';
import { teamsMemberActions } from '../teams-members';
import { getTeamMemberById } from './selectors';

export function* fetchTeamMemberById({ payload }) {
  const { teamsMemberId, teamId } = payload;

  const teamMember = yield select(getTeamMemberById, teamsMemberId);

  if (!teamMember || teamMember.isNew) {
    yield call(fetchTeamMemberByIds, teamsMemberId, { teamsMemberId, teamId });
  }
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchFetchTeamMemberById() {
  yield takeLatest(teamsMemberActions.FETCH_TEAM_MEMBER_BY_ID, fetchTeamMemberById);
}

//=====================================
//  ROOT
//-------------------------------------

export const teamMemberSagas = [
  fork(watchFetchTeamMemberById),
];